import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { SessionService } from '../../services/session.service';

function isAdminRole(roleName: string | null | undefined): boolean {
  return String(roleName ?? '').trim().toUpperCase().includes('ADMIN');
}

export const normalDashboardRoleGuard: CanActivateFn = () => {
  const router = inject(Router);
  const sessionSvc = inject(SessionService);

  return isAdminRole(sessionSvc.getProfileDetails()?.role_name)
    ? router.parseUrl('/admin-dashboard')
    : true;
};

export const adminDashboardRoleGuard: CanActivateFn = () => {
  const router = inject(Router);
  const sessionSvc = inject(SessionService);

  return isAdminRole(sessionSvc.getProfileDetails()?.role_name)
    ? true
    : router.parseUrl('/dashboard');
};
